export default "__VITE_ASSET__BoPtOYbg__"